import React , {useEffect , useState} from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import DashboardNav from "../../Components/DashboardHeader/DashboardNav";
import { Link } from "react-router-dom";
import { Form,Spinner } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import { getUserByKeyword, getErrorByField } from "../../Api/auth";
import { getCurrentUser } from "../../Api/auth";
import { getremotefittingdatabyfitter } from "../../Api/iron";

function ListFitter() {

    const [keyword, setKeyword] = React.useState("");
    const [validated, setValidated] = React.useState(false);
    const [errors, setErrors] = React.useState([]);
    const [apicall, setApicall] = React.useState(false);
    const [userList, setUserList] = React.useState([]);
    const [customerId, setCustomerId] = React.useState(null);
    const [respCode, setResCode] = React.useState(0);

    const handleSearchChange = (e) => {
        setCustomerId(e.target.value);
        setKeyword(e.target.value);

    }

    const handlegetCustomer = (event) => {
        setApicall(true);
        event.preventDefault();
        const data = {
            params: { keyword },
        }
        getUserByKeyword(data, event).then((res) => {
            console.log(res);
            if (!res.data.status) {
                setErrors(res.data.error);
                alert(res.data.message);
            }
            else {
                setUserList(res.data.data);
            }
            setResCode(res.data.status);
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
        });
        setValidated(true);
    }


    const [userdata, setUserdata] = React.useState(null);
    const [user_id, setUser_id] = React.useState(0);


    useEffect(() => {
        // setUserdata(getCurrentUser());
        const fetchUserData = async () => {
            try {
                const userData = await getCurrentUser();
                if (userData) {
                    setUserdata(userData);
                    setUser_id(userData.user._id);
                } else {
                    // Handle case where user data is missing or incomplete
                    console.error('User data is missing or incomplete.');
                }
            } catch (error) {
                // Handle any errors that occur during data fetching
                console.error('Error fetching user data:', error);
            }
        };

        fetchUserData();
    }, []);


    useEffect(() => {
        // Ensure user_id is not undefined, null, or any falsy value before calling getfittingdata
        if (user_id) {
            getfittingdata();
        }
    }, [user_id]);

    const getfittingdata = () => {
        const data = {
            fitter_id: user_id
        };
        getremotefittingdatabyfitter(data).then((response) => {
            if (!response.data.status) {
                alert(response.data.message);
            } else {
                const data = response.data.data;
                if (userdata && userdata.user.role_id === 1) {
                    if (data && data.opencloseStatus === 'open') {
                        
                    }else{
                        window.location.href = '/pay-now';
                    }
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    };




    return (
        <div>
            <div className="main-page-body-content-header">
                <HeaderAdmin />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="sec-header-dash">
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>Select Customer</h3>
                                        </div>
                                        <div className="content-box-btn">
                                            <Link to="/add-customer?ft=iron" >
                                                <button className="btn btn-add">Add Customer</button>
                                            </Link>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="p-1 rounded shadow-sm mb-4 mt-4" style={{ background: '#fff' }}>
                                            <Form noValidate validated={validated} onSubmit={handlegetCustomer}>
                                                <div className="input-group">
                                                    <input
                                                        required
                                                        placeholder="What're you searching for?" 
                                                        aria-describedby="button-addon1"
                                                        value={keyword}
                                                        type="text"
                                                        minLength={3}
                                                        onChange={handleSearchChange}
                                                        className={`form-control dash-search-box border-0 ${errors.length > 0 ? getErrorByField(errors, "email").length > 0 ? "is-invalid" : "" : ""}`}
                                                    />
                                                    <div className="input-group-append">
                                                        {
                                                            apicall ? (
                                                                <button id="button-addon1" className="btn btn-link searchbaar-btn disable" >
                                                                    <Spinner animation="border" className="border-black" />
                                                                </button>
                                                            ) : (
                                                                <button id="button-addon1" type="submit" className={`btn btn-link searchbaar-btn ${keyword.length < 4 ? 'disabled' : ''}`}>
                                                                    <FaSearch />
                                                                </button>

                                                            )
                                                        }

                                                    </div>
                                                </div>
                                            </Form>
                                        </div>

                                        {customerId == null ? "" :
                                            <>
                                                {
                                                    userList.length === 0 && respCode !== 0 ? (
                                                        <div className="no-data-found">
                                                            <div className='no-data-img'>
                                                                <img src={require("../../assets/images/logo_text.png")} alt="" />
                                                            </div>
                                                            <div className="no-data-text">
                                                                <h3>No Customer Found</h3>
                                                            </div>
                                                            <div className='no-data-btn'>
                                                                <Link to="/add-customer">
                                                                    <button className="btn btn-add">Add Customer</button>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        userList.map((user, index) => (
                                                            <div className="form-box-section mt-3" key={index}>
                                                                <div className="profile">
                                                                    <div className="profile-details">
                                                                        <div className="user-name">
                                                                            <h3>{`${user.firstname} ${user.lastname}`}</h3>
                                                                        </div>
                                                                        <div className="user-email">
                                                                            {user.email}
                                                                        </div>
                                                                    </div>
                                                                    <div className="content-box-btn">
                                                                        <Link to={`/club_fitting/${user._id}`} >
                                                                            <button className="btn btn-edit">Select</button>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    )
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div>
    );
}

export default ListFitter;